import { enUS, esES, frFR, deDE, itIT, ptBR } from "@mui/x-date-pickers/locales";

const MAP = {
  en: enUS,
  es: esES,
  fr: frFR,
  de: deDE,
  it: itIT,
  pt: ptBR,
};

export function getPickersLocaleText(lang) {
  const base = (lang || "en").replace("_", "-").split("-")[0].toLowerCase();
  const pack = MAP[base] ?? enUS;
  return pack.components.MuiLocalizationProvider.defaultProps.localeText;
}
